import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const visitorSummary = styled(Modal)`

border-radius: 15px 15px 0px 0px;
  
  &.visitor-modal{
    width: 700px !important;
  }
  button.ant-btn.ant-btn-default.cancel-button{
    width: 100% !important;
  }
  .ant-btn-primary{
    background-color: #0B2A1B!important;
  }
  .ant-modal-body{
    padding: 0;
  }
  
  .form-title{
    padding: 16px 24px;
    border-bottom: 1px solid #eaeef1;
    h3{
      font-size: 1rem;
      color: #0B2A1B;
    }
  }
  .form-body{
    padding: 12px 24px 12px 24px;
    .checkbox-contact{
      margin-bottom: 10px;
    }
  }
  .dot-btn {
    span {
      rotate: 90deg;
      cursor: pointer;
    }
  }

  
  .manage-property-title {
    color: #101828;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
  }
  .manage-property-table {
    border: 1px solid #eaecf0;
    box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1),
      0px 1px 2px rgba(16, 24, 40, 0.06);
    border-radius: 12px;
    background: white;
    .ant-pagination {
      padding: 24px;
    }
    .add-property-btn {
      background: #f80e46;
      border-radius: 8px !important;
      color: #fff;
    }
    .m-p-main {
      padding: 24px;
      display: flex;
      justify-content: space-between;
    }
    .dropdown {
      border: 1px solid #d0d5dd !important;
    }
  }
  .action-btn {
    font-size: 12px;
    line-height: 24px;
    background: #535763;
    border-radius: 10px !important;
    border-color: transparent !important;
    color: white;
  }
  .button-group {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
  
  .fAgWDa .ant-table-content {
    overflow-x: unset;
  }
  .fAgWDa {
    overflow-x: unset;
  }
  .dtr-data {
    white-space: break-spaces;
  }
  .delete-button {
    margin-left: 5px;
  }

  /* One induction in the history list: description on the left, its action
     pinned to the right edge so the button reads as a control rather than as
     another line of text. Wraps instead of squashing on a narrow screen. */
  .induction-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
  }
  .induction-row-detail {
    min-width: 0;
  }
  /* View / Verify / Reject sit together on the right. They wrap as a group so a
     narrow drawer never strands Reject on its own line under the text. */
  .induction-row-actions {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    flex-wrap: wrap;
  }
  .induction-verify-btn button.ant-btn {
    color: #fff;
  }
  .induction-verify-btn,
  .induction-reject-btn {
    flex-shrink: 0;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  /* Why it was refused — the one line of this block that someone has to read,
     so it is not the same grey as the timestamps above it. */
  .induction-rejected-reason {
    color: #b42318;
    white-space: normal;
  }
  .induction-view-btn {
    flex-shrink: 0;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    /* The drawer forces every primary button to the dark brand colour; this is
       a secondary action, so it stays outlined and only picks the colour up on
       hover. */
    &:hover,
    &:focus {
      color: #0b2a1b;
      border-color: #0b2a1b;
    }
  }
`;

export default WithDirection(visitorSummary);